// src/App.js
import HomePage from "./page/HomePage.jsx";
import "./styles/home-page.css";
function App() {
  return (
    <div className="app">
      <HomePage />
    </div>
  );
}

export default App;
